import type { ReactNode } from 'react';
import { App as AntdApp, ConfigProvider } from 'antd';
import type { Locale } from 'antd/es/locale';
import ruRUImport from 'antd/locale/ru_RU';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { useBreakpoint } from '@/shared/lib/hooks';
import { ownerMobileTheme, ownerTheme } from './theme';

// Under Vite, this deep CJS subpath sometimes comes through double-wrapped as
// `{ default: Locale }` instead of `Locale` — unwrap defensively either way, otherwise
// `ConfigProvider` silently falls back to English for every built-in antd string.
const ruRU: Locale = (ruRUImport as unknown as { default?: Locale }).default ?? ruRUImport;

// Global dayjs locale — antd's own components read locale from ConfigProvider below, but any
// direct `dayjs(...).format(...)` call uses dayjs's own singleton, which stays 'en' unless set here.
dayjs.locale('ru');

/** Владельческая тема (§1: 12px везде, без скруглений, плотные таблицы). Кабинет клиента
 *  переопределяет её вложенным ConfigProvider (см. ClientLayout). */
export function AntdProvider({ children }: { children: ReactNode }) {
  // Телефон (< 768px) — отдельная тема с крупными контролами; десктоп остаётся прежним (12px/small).
  const { isMobile } = useBreakpoint();
  return (
    <ConfigProvider locale={ruRU} theme={isMobile ? ownerMobileTheme : ownerTheme} componentSize={isMobile ? 'middle' : 'small'}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}
